import { useEnvironmentVariables, useGetCurrentUserSuspenseQuery } from "@workleap-ai/shared";
import { useLoadAndInitializeNavbar, type UseLoadAndInitializeNavbarOptions } from "@workleap-platform/navbar/react";
import { useMemo } from "react";

export const useNavbar = () => {
    const { data: { language } } = useGetCurrentUserSuspenseQuery();
    const { navigationBarEnvironment } = useEnvironmentVariables();

    const settings: UseLoadAndInitializeNavbarOptions = useMemo(() => ({
        language,
        onError: () => {}
    }), [language]);

    return useLoadAndInitializeNavbar("wai", navigationBarEnvironment, settings);
};
